import Vue from 'vue'
import 'babel-polyfill'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import {catchError,fuzzyFilter,Cookie,getPath} from '@/util'
import '../Mock/mock'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/reset.css'
import '@/assets/css/global.css'
import '@/assets/css/eleReset.scss'
import TableScrollManager from '@/util/TableScrollManager'
import ListRangeManager from '@/util/ListRangeManager'
import {mapMutations} from 'vuex'
import TableHeaderFixed from '@/components/Util/TableHeaderFixed'

if (process.env.NODE_ENV !== "development") {
  console.log = function() {}
  console.logObj = function() {}
}



Vue.component('th-fixed',TableHeaderFixed)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$catchErr = catchError
Vue.prototype.$fuzzyFilter = fuzzyFilter
Vue.prototype.$TableScrollManager = TableScrollManager
Vue.prototype.$ListRangeManager = ListRangeManager
Vue.prototype.$getPath = getPath
if(location.hash.includes('env=out')) {
  localStorage.setItem('env','out')
}
window.$cookie = Cookie

const popper = {
  ...mapMutations(['setPopperConfig'])
}
Vue.prototype.$setPopperConfig = popper.setPopperConfig
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js